// @flow strict-local

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {displayTime} from 'src/utils/date-time-2';

import {ConfirmButton} from './confirm-button.jsx';

import css from '../booking.css';


export const TimePicker = ({
  possibleTimes,
  selectedDate,
  // dateAsKey,
  onConfirmTimeslot,
  color,
  showConfirm,
}: {
  possibleTimes: {start_time: string, end_time: string}[],
  selectedDate: Date,
  // dateAsKey: string,
  onConfirmTimeslot: (startTime: string) => mixed,
  color?: ?string,
  showConfirm: boolean,
}): React.Element<typeof React.Fragment> => {
  const CHUNK_SIZE = 5;
  const [loadedIndex, setLoadedIndex] = React.useState(CHUNK_SIZE);
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const times = possibleTimes.slice(0, loadedIndex);

  const [submitting, setSubmitting] = React.useState(false);
  const [selectedTime, setSelectedTime] = React.useState();

  return (
    <React.Fragment key={selectedDate.toISOString()}>
      <p className={css.scheduleDateSubtitle}>
        {t('Times_with_shared_availability', 'Times with shared availability')}
      </p>
      {times.map((time) => {
        const [hour, minute] = time.start_time.split(':');
        const datetime = new Date(selectedDate);
        datetime.setHours(Number(hour));
        datetime.setMinutes(Number(minute));

        return (
          <ConfirmButton
            key={time.start_time}
            selected={selectedTime === time.start_time}
            onFirstClick={() => setSelectedTime(time.start_time)}
            disabled={submitting}
            onConfirmClick={async () => {
              setSubmitting(true);
              try {
                await onConfirmTimeslot(time.start_time);
              } catch (err) {
                console.error(err);
              } finally {
                setSubmitting(false);
              }
            }}
            color={color}
            showConfirm={showConfirm}
          >
            {submitting && selectedTime === time.start_time
              ? `${t('Saving', 'Saving')}...`
              : displayTime(datetime)}
          </ConfirmButton>
        );
      })}
      {loadedIndex < possibleTimes.length && (
        <button onClick={() => setLoadedIndex((prev) => prev + CHUNK_SIZE)}>
          {t('load_more_times', 'load more times')}
        </button>
      )}
    </React.Fragment>
  );
};
